import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { schema as shared } from '../../../../lightings/lightings-1/sections/footer/footer.schema'

const SOCIAL_PLATFORMS = ['facebook', 'instagram', 'youtube', 'tiktok', 'linkedin', 'x']
  .map(value => ({ label: value === 'x' ? 'X' : value[0]!.toUpperCase() + value.slice(1), value }))

/**
 * Pathok footer: the shared footer fields (stored data stays portable) with the platforms its icons
 * support. Phone, email and addresses fall back to Store info.
 */
export const schema: ComponentSchema = {
  ...shared,
  label: 'Footer',
  description: 'Brand column, link columns, contact (from Store info) and payment badges.',
  variants: [{ id: 'v1', label: 'Tint' }],
  commonFields: shared.commonFields
    .filter(f => f.key !== 'title')
    .map((f): FieldSchema => (f.key !== 'socialLinks'
      ? f
      : { ...f, itemSchema: f.itemSchema?.map(i => (i.key === 'platform' ? { ...i, options: SOCIAL_PLATFORMS } : i)) })),
}
